import React, { useEffect } from "react";
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import axios from 'axios';
import { getToken } from '../config/services/token'
import { userActivityLog } from '../config/services/activityLog';
import { EncryptData } from '../utils/encryptDecrypt';
import EnvSettings from "../config/settings";
import { decodedToken } from "../utils/Reusables";
export default function SetUsername() {
    localStorage.clear()
    const UrlParams = useParams()
    const navigate = useNavigate()
    let { id } = UrlParams
    id = id?.trim()

    let fetchToken = async (params) => {
        let tokenObj = await getToken(params)
        return tokenObj?.data
    }
    const search = useLocation().search;
    let role = new URLSearchParams(search).get('role');
    role = role ? role.trim() : '';
    const school_code = new URLSearchParams(search).get('school_code');
    let email = new URLSearchParams(search).get('email');
    email = email ? email.trim() : '';
    const redirectURL = new URLSearchParams(search).get('redirectURL');
    const language = new URLSearchParams(search).get('lang');
    const appType = new URLSearchParams(search).get('app');
    const additionalFilters = new URLSearchParams(search).get('additionalFilters');
    
    let trackingEvent = {
        em_guid: id,
        uuid: id,
        landing_page: redirectURL,
        action: "setCreds",
        date_time: new Date().toISOString(),
        platform: "Report-Engine",
        envirnment: EnvSettings?.env,
        app_version: EnvSettings?.version,
        browser: navigator?.userAgent,
        os_details: navigator?.platform,
        event_type: "Page-View",
        eventStep: "setCreds",
        click_type: "Page-View",
        value: `Role:${role}_Lang:${language}_SchoolCode:${school_code}`,
    }

    useEffect(() => {
        ///setcreds/aa9111d0-3947-4571-b5bb-b6da66ade308?school_code=EM0591&role=SCHOOLADMIN&redirectURL=/embedDashboard/620fb41accb4cc001268e069&lang=en
        let referrer = document.referrer;
        //referrer = 'extramarks.com'
        //console.log('Referrer',referrer)
        if (!referrer) {
            navigate("/unauthorised")
        }
        else if (referrer && !referrer.includes('extramarks') && !referrer.includes('localhost')) {
            navigate("/unauthorised")
        } else
        {
            let encryptedId = EncryptData(id)
            localStorage.setItem('username', encryptedId)
            localStorage.setItem('uuid', encryptedId)
            localStorage.setItem('s_uuid', encryptedId)
            localStorage.setItem('t_uuid', EncryptData(JSON.stringify([id])))
            localStorage.setItem('s_uuids', EncryptData(JSON.stringify([id])))
            localStorage.setItem('appType', appType)
            if (school_code)
                localStorage.setItem('school_code', EncryptData(JSON.stringify([school_code])))

            if (language)
                localStorage.setItem('lang', EncryptData(language));


            if (email)
                localStorage.setItem('email', EncryptData(email))

            if (additionalFilters){
                const decodedCrmFilters = decodeURIComponent(additionalFilters);
                if(decodedCrmFilters){
                    localStorage.setItem('additionalFilters',decodedCrmFilters);
                }
            }
            localStorage.setItem('role', EncryptData(role || 'DS'))

            const data = {
                uuid: id,
                school_code: school_code,
                role: role ? role : 'DS'
            }
            fetchToken(data)
                .then(userDetail => {
                    if (userDetail) {
                        localStorage.setItem('accessToken', userDetail.token)
                        axios.defaults.headers.common['accessToken'] = userDetail.token;

                        if (userDetail.cubeToken) {
                            localStorage.setItem('cubeToken', userDetail.cubeToken)
                            const decoded = decodedToken(userDetail?.cubeToken)
                            if(decoded && decoded?.school_code) {
                                localStorage.setItem('school_code', EncryptData(JSON.stringify(decoded?.school_code)))
                            }
                        }
                        if (userDetail.menusAllowed) {
                            localStorage.setItem('menusAllowed', EncryptData(JSON.stringify(userDetail.menusAllowed)))
                        } else {
                            localStorage.removeItem('menusAllowed')
                        }
                        if(userDetail.userType){
                            localStorage.setItem('userTypeId', EncryptData(userDetail?.userType?._id))
                        }
                        userActivityLog(trackingEvent) // To Track User
                        if (redirectURL) {
                            if (language) {
                                navigate(redirectURL, { state: language })
                            }
                            else {
                                navigate(redirectURL)
                            }
                        }
                        else {
                            navigate('/dashboard')
                        }
                    } else {
                        localStorage.clear()
                        navigate("/unauthorised")
                    }
                })
        }
    }, [])

    return (
        <>
            Loading.....
        </>
    );
}
